export default {
  "header": {
    "title": "Listas de verificação digitais"
  },
  "card": {
    "list": {
      "title": "Listas",
      "create": "Criar listas",
      "name": "Nome",
      "click": "Clique para adicionar item",
      "delete": "Remover",
      "action": "Ações",
      "label_alert": "O nome da lista deve ter pelo menos uma letra",
      "legend_text": "Nenhuma lista criada",
      "placeholder": "Adicionar uma lista ...",
      "label": "Adicione outra lista pressionando Enter ou cancele pressionando Esc"
    },
    "item": {
      "title": "Lista de itens",
      "tooltip_err_mes": "Você deve selecionar uma lista para adicionar um item",
      "create": "Adicionar Item",
      "delete": "Remover",
      "edit": "Editar",
      "new_items": "-novos itens criados",
      "edited_items": "-itens editados",
      "delete_items": "-itens deletados",
      "name": "Nome",
      "action": "Ações",
      "legend_text": "Nenhum item criado",
      "label": "Adicione outro item pressionando Enter ou cancele pressionando Esc.",
      "label_alert": "O nome do item deve ter pelo menos uma letra ou número",
      "placeholder": "Adicionar um item à lista",
      "btn_cancel": "Cancelar",
      "btn_save": "Salvar"
    },
    "input": {
      "addItemLabel": "adicionar Item",
      "labelAlert": "O nome da lista deve ter pelo menos uma letra ou número"
    },
    "toastrLable": {
      "success": "Lista criada com sucesso",
      "info": "Em formação",
      "error": "A lista não foi criada",
      "deletError": "A lista não foi excluída",
      "itemDeleteSuccess": "Item excluído com sucesso",
      "listDeleteSuccess": "Lista excluída com sucesso",
      "itemEditSuccess": "Item editado com sucesso",
      "confirm": "Sim",
      "cancel": "Não",
      "question": "Tem certeza de que deseja excluir",
      "list": "a lista",
      "item": "o item",
      "err": "Erro",
      "caution": "Excluir uma lista que está sendo usada por uma lista de verificação digital",
      "caution1": "pode gerar um comportamento inesperado.",
      "deleteItem": "Excluir o item",
      "editItem": "Editar Item",
      "change": "Informações salvas com sucesso",
      "notChange": "As alterações não foram salvas",
      "save": "Tem certeza de que deseja salvar as seguintes alterações na lista",
      "_cancel": "Tem certeza que deseja cancelar as alterações feitas na lista"
    }
  }
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/portuguese/dynamic_list.js